module.exports = __webpack_public_path__ + "static/img/1.c76a06b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/eng/1.png
// module id = KbRR
// module chunks = 0